import React from 'react';
import './FooterSmall.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';

const FooterSmall: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footerSmall'>
      <div className='footerSmallContent'>
        <div className='footerSmallText'>
          <div className='footerItem'>ICE GEMS, Inc.</div>          
          <div className='footerItem'>
            <Link to="/contact" >Contact</Link>
          </div>
          <div className='footerItem'>
            <a href="mailto:Contact@IceGems.com">Contact@IceGems.com</a>
          </div>
          <div className='footerItem'>
            <a href="tel:4132404326">(413)-240-4326</a>
          </div>
          <div className='socialMedia'>
            <a href='https://www.youtube.com/channel/UCgubB1wK55iyCO0qTlQ22Yg'>
              <FontAwesomeIcon icon={faYoutube} size='2x' />
            </a>

            <a href='https://www.linkedin.com/company/ice-gems-inc/'>
              <FontAwesomeIcon icon={faLinkedin} size='2x' />
            </a>
          </div>
          <div className='footerItem'>
            ALL RIGHTS RESERVED © ICE GEMS, Inc. {currentYear}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSmall; 